import queryString from 'query-string'
import React, { memo } from 'react'
import { handleDataLayerEvent, handleGAEvent } from '../common/googleAnalytics'
import { getAppEventName } from '../../../utils/services/googleAnalytics'
import { appConfig } from '../common/constants'
import { getProductOriginURL } from '../../../utils/config'

export const handleRelatedProductClick = (props) => {
  const editedInput = props.injectionResin
    ? {
        injectionResin: props.injectionResin,
        pasteOverEpoxy: props.pasteOverEpoxy,
        linkNameClicked: props.linkName,
      }
    : {
        insertType: props.insertType,
        adhesiveAnchor: props.adhesiveAnchor,
        linkNameClicked: props.linkName,
      }

  let appEventName = getAppEventName(appConfig.appCode, props.source === 'EC')

  handleGAEvent({
    appEventName,
    gaActionName: 'Click_Link_Action',
    gaLabelName: 'Click_Related_Product_Link',
    input: editedInput,
  })

  handleDataLayerEvent({
    appEventName,
    appAction: 'Click_Link_Action',
    appInputs: props.isAdhesiveMainProductLink
      ? `${props.productInfo.product} ${props.productInfo.shortDesc}`
      : props.item.title,
  })
}

const RelatedImageList = (props) => {
  const params = window.location.search ? queryString.parse(window.location.search) : {}

  return (
    <div>
      {props.relatedImages.map((item, index) => (
        <a
          className="relatedProduct"
          href={
            props.source === 'EC'
              ? item.productUrlEC && `${getProductOriginURL()}/${item.productUrlEC}`
              : item.productUrl
          }
          target="_blank"
          key={index + 1}
          title={item.title}
          onMouseDown={() => handleRelatedProductClick({ ...props, item })}
        >
          <img src={item.imageUrl} alt={item.alt} />
          <div className="relatedProduct__name">{item.title}</div>
        </a>
      ))}
    </div>
  )
}

export default memo(RelatedImageList)
